import { render, staticRenderFns } from "./SingleProductView.vue?vue&type=template&id=59961d0c&scoped=true&"
import script from "./SingleProductView.vue?vue&type=script&lang=js&"
export * from "./SingleProductView.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductView.vue?vue&type=style&index=0&id=59961d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../myscore_frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59961d0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../myscore_frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
